import React, { useState, useRef } from "react";
import "./TransformationsSection.css";

// Import your image files here
import img1 from "../assets/P1.jpg";
import img2 from "../assets/P2.jpg";
import img3 from "../assets/P3.jpg";
// import img4 from "../assets/P4.jpg";
import img5 from '../assets/TO.jpg'
import img6 from '../assets/P5.jpg'
import img7 from '../assets/P6.jpg'
import img8 from '../assets/P7.jpg'
import img9 from '../assets/P8.jpg'


const galleryImages = [img1, img2, img3,img5,img6,img7,img8,img9];

function TransformationsSection() {
  const scrollRef = useRef(null);
  const [selectedImage, setSelectedImage] = useState(null);

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: 320, behavior: "smooth" });
    }
  };

  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: -320, behavior: "smooth" });
    }
  };

  return (
    <section className="transformations-section">
      {/* Top Header Text Section */}
      <div className="section-header">
        <div className="header-text">
          <p className="sub-title">— SPECIAL TREATMENT PACKAGES</p>
          <h2 className="main-title">Our Treatments & Offers

</h2>
        </div>
        <p className="header-description">
          Save more with our carefully curated treatment packages. Combine complementary treatments for a complete approach to your skin goals.
        </p>
      </div>

      {/* Horizontal Image Carousel */}
      <div className="carousel-wrapper">
        <button className="scroll-btn left-btn" onClick={scrollLeft} aria-label="Scroll left">
          ‹
        </button>

        <div className="image-row" ref={scrollRef}>
          {galleryImages.map((image, index) => (
            <div
              key={index}
              className="image-card"
              onClick={() => setSelectedImage(image)}
            >
              <img src={image} alt={`Transformation ${index + 1}`} />
            </div>
          ))}
        </div>

        <button className="scroll-btn right-btn" onClick={scrollRight} aria-label="Scroll right">
          ›
        </button>
      </div>

      {/* Full-Screen Modal Lightbox */}
      {selectedImage && (
        <div
          className="fullscreen-modal"
          onClick={() => setSelectedImage(null)}
        >
          <button
            className="close-btn"
            onClick={() => setSelectedImage(null)}
            aria-label="Close modal"
          >
            ✕
          </button>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <img src={selectedImage} alt="Transformation Full View" />
          </div>
        </div>
      )}
    </section>
  );
}

export default TransformationsSection;